import { IconProps } from '../icon';

export function StatistiqueIcon(props: IconProps) {
  return (
    <svg
      id="Statistique"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="39.916"
      height="40"
      viewBox="0 0 39.916 40"
      {...props}
    >
      <defs>
        <clipPath id="clipPath">
          <rect
            id="Rectangle_326"
            data-name="Rectangle 326"
            width="39.916"
            height="40"
            fill="none"
          />
        </clipPath>
        <clipPath id="clipPath-3">
          <rect
            id="Rectangle_323"
            data-name="Rectangle 323"
            width="29.924"
            height="38.311"
            fill="none"
          />
        </clipPath>
        <clipPath id="clipPath-4">
          <rect
            id="Rectangle_324"
            data-name="Rectangle 324"
            width="19.984"
            height="19.988"
            fill="none"
          />
        </clipPath>
      </defs>
      <g id="Groupe_608" data-name="Groupe 608" clipPath="url(#clipPath)">
        <g id="Groupe_607" data-name="Groupe 607">
          <g id="Groupe_606" data-name="Groupe 606" clipPath="url(#clipPath)">
            <g
              id="Groupe_602"
              data-name="Groupe 602"
              transform="translate(0 1.689)"
              opacity="0.5"
            >
              <g id="Groupe_601" data-name="Groupe 601">
                <g
                  id="Groupe_600"
                  data-name="Groupe 600"
                  clipPath="url(#clipPath-3)"
                >
                  <path
                    id="Tracé_243"
                    data-name="Tracé 243"
                    d="M18.252,33.893c0,2.785.012,5.571-.01,8.356a2.135,2.135,0,0,0,.5,1.421q5.386,6.886,10.739,13.8c.651.838.6,1.109-.227,1.8a14.855,14.855,0,0,1-10.856,3.241,19.149,19.149,0,0,1-11.022-4.05A18.345,18.345,0,0,1,.084,45.169c-.593-7.327,1.927-13.387,7.852-17.858A15.14,15.14,0,0,1,17.1,24.236c.946-.009,1.147.186,1.15,1.145.007,2.837,0,5.675,0,8.512"
                    transform="translate(0 -24.236)"
                    fill="#8eac12"
                  />
                </g>
              </g>
            </g>
            <g
              id="Groupe_605"
              data-name="Groupe 605"
              transform="translate(19.932)"
              opacity="0.3"
            >
              <g id="Groupe_604" data-name="Groupe 604">
                <g
                  id="Groupe_603"
                  data-name="Groupe 603"
                  clipPath="url(#clipPath-4)"
                >
                  <path
                    id="Tracé_244"
                    data-name="Tracé 244"
                    d="M285.949,10q0-4.332,0-8.664c0-1.148.2-1.342,1.374-1.332a19.2,19.2,0,0,1,18.145,14.968,18.92,18.92,0,0,1,.463,3.783c.01.942-.264,1.232-1.18,1.233q-8.821.006-17.641,0c-.889,0-1.158-.276-1.159-1.167q-.007-4.41,0-8.82"
                    transform="translate(-285.948 0)"
                    fill="#8eac12"
                  />
                </g>
              </g>
            </g>
            <path
              id="Tracé_245"
              data-name="Tracé 245"
              d="M319.574,310.349c2.6,0,5.2,0,7.8,0,1.138,0,1.384.245,1.334,1.392a19.066,19.066,0,0,1-5.58,12.934c-.962.982-1.24.968-2.091-.085q-4.732-5.855-9.457-11.715c-.278-.344-.547-.695-.834-1.031a.863.863,0,0,1,.71-1.492c.468-.013.936,0,1.4,0h6.711"
              transform="translate(-288.828 -288.714)"
              fill="#8eac12"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default StatistiqueIcon;
